import React from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'semantic-ui-react'
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';

import moment from 'moment'

const VocationalQualification = ({
  isViewAsTeacher,
  qualType,
  qualifications,
  showEditQual,
  setQTarget,
  setQType,
  toogleShowConfirmModal,
}) => {
  return qualifications && qualifications.length > 0 ? (
    <ul className='container p-0'>
      {qualifications
        .sort((a, b) => {
          let dateA, dateB;
          dateA = a.graduation_date === "Present" ? moment() : moment(a.graduation_date, "MM/YYYY")
          dateB = b.graduation_date === "Present" ? moment() : moment(b.graduation_date, "MM/YYYY")
          return dateB.diff(dateA)
        })
        .map((q, index, array) => {
          return (
            <li key={q._id} className='row'>
              <div className='col-8'>
                <p className={'mb-2 profile-qualification-title text-left' +
                (q.degree === "No VET Training Qualification" ? ' font-weight-normal' : '')}
                >
                  {q?.status === "approved" ? <VerifiedUserOutlinedIcon sx={{color: 'green'}} /> : <VerifiedUserOutlinedIcon/>}
                  {q.degree} {q.award_name}
                </p>
                {q.course_code ? (
                  <p className='mb-2 profile-qualification-title text-left'>
                    ({q.course_code})
                  </p>
                ) : (
                  ''
                )}
                {q.institution_name ?
                  <p className='mb-2 profile-qualification-place text-left'>
                    {q.institution_name}{q.institution_city ? `, ${q.institution_city}` : ''}{q.institution_country ? `, ${q.institution_country}` : ''}
                  </p>
                : ""}

                <p className='profile-qualification-place text-left'>
                  <Icon
                    name='file text outline'
                    onClick={() => showEditQual(q)}
                    className='qualification-container-update-icon'
                    hidden={q.degree === "No VET Training Qualification"}
                  >
                    {' '}
                  </Icon>
                  {q.graduation_date === 'Present' ? (
                    <Link
                      to={{
                        pathname: `/NavigateToFileViewer?fileurl=${q.enrolment_url}`,
                      }}
                      target='_blank'
                      className='profile-qualification-place'
                    >
                      SOE
                    </Link>
                  ) : (
                    <>
                      {q.qualification_url ? (
                        <Link
                          to={{
                            pathname: `/NavigateToFileViewer?fileurl=${q.qualification_url}`,
                          }}
                          target='_blank'
                          className='profile-qualification-place'
                        >
                          Certificate
                        </Link>
                      ) : (
                        ''
                      )}
                      {q.qualification_url && q.transcript_url ? ' | ' : ''}
                      {q.transcript_url ? (
                        <Link
                          to={{
                            pathname: `/NavigateToFileViewer?fileurl=${q.transcript_url}`,
                          }}
                          target='_blank'
                          className='profile-qualification-place'
                        >
                          Transcript
                        </Link>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                </p>
              </div>

              <div className='col-4'>
                <p
                  className='mt-0 mb-2 profile-qualification-title text-right'
                  hidden={q.degree === "No VET Training Qualification"}
                >
                  {q.graduation_date !== 'Present' ? (
                    // q.graduation_date.length === 7 ? (
                    moment(q.graduation_date, 'MM/YYYY').format('MMM YYYY')
                    // ) : (
                    //   'NaN'
                    // )
                  ) : (
                    <p className='mt-0 mb-0 profile-qualification-title text-right'>
                      Currently Enrolled
                    </p>
                  )}
                </p>
                {isViewAsTeacher ? (
                  <p className='mb-0 profile-qualification-title text-right'>
                    <Icon
                      name='pencil'
                      circular
                      inverted
                      color='#3bb4d8'
                      onClick={() => showEditQual(q)}
                      className='qualification-container-update-icon'
                    >
                      {' '}
                    </Icon>
                    <Icon
                      name='trash'
                      circular
                      inverted
                      color='grey'
                      onClick={() => {
                        setQTarget(q)
                        setQType(qualType)
                        toogleShowConfirmModal(true)
                      }}
                      className='qualification-container-update-icon'
                    >
                      {' '}
                    </Icon>
                  </p>
                ) : null}
              </div>
              {index !== array.length - 1 && (
                <div className='col-12'>
                  <hr className='qualification-line-1 my-3'></hr>
                </div>
              )}
            </li>
          )
        })}
    </ul>
  ) : null
}

export default VocationalQualification
